import Logo from "../Assets/img/logo-31.svg";
import React, { useState } from "react";
import { IoReload } from "react-icons/io5";
import { GoGear } from "react-icons/go";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoMdMenu, IoMdClose } from "react-icons/io";
import StrategiesBody from "./StrategiesBody";

const navItems = ["Lend", "Swap", "Strategies", "SEND", "Bridge", "More"];

const SwapCard = ({ setShowModal }) => {
  const [activeTab, setActiveTab] = useState("Lend");
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <>
      <nav className="sticky top-0 z-50 bg-[#020917] border-b border-gray-800 backdrop-blur-md">
        <div className="px-4 mx-auto max-w-7xl">
          {/* Top Bar */}
          <div className="flex items-center justify-between h-14">
            {/* Logo */}
            <div className="flex items-center gap-2 text-white">
              <img src={Logo} alt="logo" className="w-auto h-6 opacity-95" />
              <span className="text-lg">Suilend</span>
            </div>

            {/* Desktop Menu */}
            <div className="items-center hidden gap-6 text-sm font-medium md:flex">
              {navItems.map((item) => (
                <button
                  key={item}
                  onClick={() => setActiveTab(item)}
                  className={`relative transition ${
                    activeTab === item
                      ? "text-[#2469FF]"
                      : "text-gray-300 hover:text-[#2469FF]"
                  }`}
                >
                  {item}
                  {activeTab === item && (
                    <span className="absolute -bottom-2 left-0 w-full h-0.5 bg-[#2469FF] rounded" />
                  )}
                </button>
              ))}
            </div>

            {/* Right Actions */}
            <div className="flex items-center gap-3 text-gray-300">
              <button className="transition hover:text-white">
                <IoReload size={18} />
              </button>
              <button className="transition hover:text-white">
                <GoGear size={18} />
              </button>

              {/* Connect Button */}
              <button
                onClick={() => setShowModal(true)}
                className="flex items-center gap-1 px-4 py-1.5 text-sm text-white bg-[#2469FF] hover:bg-[#1d55d0] rounded shadow-md  transition"
              >
                CONNECT
                <MdKeyboardArrowDown />
              </button>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setMobileOpen(!mobileOpen)}
                className="text-white md:hidden"
              >
                {mobileOpen ? <IoMdClose size={22} /> : <IoMdMenu size={22} />}
              </button>
            </div>
          </div>

          {/* Mobile Menu */}
          {mobileOpen && (
            <div className="py-4 space-y-3 border-t border-gray-800 md:hidden">
              {navItems.map((item) => (
                <button
                  key={item}
                  onClick={() => {
                    setActiveTab(item);
                    setMobileOpen(false);
                  }}
                  className={`block w-full text-left px-2 py-2 rounded text-sm transition ${
                    activeTab === item
                      ? "bg-[#1b3f8d] text-[#fff]"
                      : "text-gray-300 hover:bg-white/5"
                  }`}
                >
                  {item}
                </button>
              ))}
            </div>
          )}
        </div>
      </nav>

      <StrategiesBody />
    </>
  );
};

export default SwapCard;
